<div class="action">
  <i
    class="bi bi-three-dots"
    mat-icon-button
    #menuTrigger="matMenuTrigger"
    (click)="toggleMenu(menuTrigger)"
    [matMenuTriggerFor]="menu"
    aria-label="Example icon-button with a menu"></i>

  <mat-menu #menu="matMenu" xPosition="before">
    @for (action of actions; track action) {
    <button
      mat-menu-item
      class="d-flex align-items-center"
      (click)="action.fn(row)">
      @if (!isDeleted) {
      <img src="../../../../assets/images/icons/{{ action.icon }}.svg" alt="" />
      <span
        [ngStyle]="{ color: action?.color }"
        [ngClass]="{ 'mx-2': action?.icon }"
        >{{ 'Actions-List.' + action.actionName | translate }}</span
      >
      }
    </button>
    } @if (!actions.length) {
    <p class="no-action">{{'No-Actions' | translate}}</p>
    }
  </mat-menu>
</div>
